import { Stack } from '@mantine/core';
import { PatternSelect } from '../PatternSelect';
import { AutoBetAmountNumberInput } from './AutoBetAmountNumberInput';
import { AutoBetConfigurationCard } from './AutoBetConfigurationCard';
import { AutoBetMobileActions } from './AutoBetMobileActions';
import { AutoBetNumberOfBetsInput } from './AutoBetNumberOfBetsInput';
import { AutoBetPredefinedBets } from './AutoBetPredefinedBets';
import { AutoBetStartButton } from './AutoBetStartButton';
import { ConfigureAutoBetButton } from './ConfigureAutoBetButton';

export const AutoBetTab = () => {
  return (
    <Stack data-test-id="auto-bet-tab" gap={6}>
      <AutoBetAmountNumberInput />

      <AutoBetPredefinedBets />

      <AutoBetNumberOfBetsInput />

      <PatternSelect />

      <AutoBetConfigurationCard my={8} />

      <Stack gap={8} visibleFrom="lg">
        <ConfigureAutoBetButton data-test-id="configure-auto-bet-button" />

        <AutoBetStartButton data-test-id="auto-bet-start-button" />
      </Stack>

      <AutoBetMobileActions />
    </Stack>
  );
};
